import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import StockTakeStatisticsChart from './StockTakeStatisticsChart';

const StockTakeStatistics = ({ sales }) => {

  const [sales_data, setSalesData] = useState(sales);

  useEffect(() => {
    setSalesData(sales);
  }, [sales]);

  return (
    <>
      <Card className=" h-100">
        <div className="nk-ecwg nk-ecwg8 h-100">
          <div className="card-inner">
            <div className="card-title-group mb-3">
              <div className="card-title">
                <h6 className="title">Stock Statistics</h6>
              </div>
              <div className="card-tools">
              </div>
            </div>
            {/* <ul className="nk-ecwg8-legends">
              <li>
                <div className="title">
                  <span className="dot dot-lg sq" style={{ background: "#6576ff" }}></span>
                  <span>Stock In</span>
                </div>
              </li>
              <li>
                <div className="title">
                  <span className="dot dot-lg sq" style={{ background: "#eb6459" }}></span>
                  <span>Stock Out</span>
                </div>
              </li>
            </ul> */}
            <div style={{ height: "350px" }}>
              <StockTakeStatisticsChart sales={sales_data} />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default StockTakeStatistics;